import { User } from 'thunks/times2Api'
import { browserHistory } from 'react-router'
import dates from 'helpers/dates'
import localForage from 'localforage'
// ------------------------------------
// Constants
// ------------------------------------
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL'
export const LOGIN = 'LOGIN'
export const AUTO_LOGIN = 'AUTO_LOGIN'
export const LOGOUT = 'LOGOUT'

export const ASK_FOR_LOGIN = 'ASK_FOR_LOGIN'

// ------------------------------------
// Actions
// ------------------------------------

export const checkIfLoggedIn = () =>{
	return (dispatch, getState) => {
		return new Promise((resolve,reject) => {
			localForage.getItem('times2User')
			.then(value => {
				if(value){
					let user = JSON.parse(value)
					let val = new Date(user.validity)
					if(dates.compare(new Date(), val, dates) == -1)
						resolve(true)
					else
						resolve(false)
				}
			})			
		})
	}
}

export const login = (credentials) => {
	return (dispatch, getState) => {
		dispatch({
			type : LOGIN,
			payload: credentials
		})
		let user = new User(credentials.user,credentials.pwd)
		return user.login()
			.then((result) => {
				dispatch({
					type : LOGIN_SUCCESSFUL,
					payload: result.data
				})
				dispatch({
					type : 'PUSH_NOTIFICATION',
					payload: `Welcome ${result.data.email}`
				})
				browserHistory.push({
					pathname: '/home',
					state: {
						...getState().location.state,
						index: 0,
					}
				})
				localForage.setItem('times2User', JSON.stringify(result.data))
			})
			.catch((result) => {
				dispatch({
					type: ASK_FOR_LOGIN
				})
				dispatch({
					type : 'PUSH_NOTIFICATION',
					payload: `Invalid credentials`
				})
			})
	}
}

export const expiredToken = () => {
	return (dispatch, getState) => {
		 dispatch({
			type : ASK_FOR_LOGIN
		})
	}
}

export const autoLogin = () => {
	 return (dispatch, getState) => {
	 	localForage.getItem('times2User')
	 	.then(times2User => {
 			if(times2User){
 				dispatch({
			 		type: AUTO_LOGIN,
			 		payload: JSON.parse(times2User)
			 	})
				dispatch({
					type : 'PUSH_NOTIFICATION',
					payload: `Welcome ${JSON.parse(times2User).email}`
				})
				browserHistory.push({
					pathname: '/home',
					state: {
						...getState().location.state,
						index: 0,
					}
				})
 			}
	 	})
	 }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[LOGIN]: (state, action) => {
		return { ...state, loading: true}
	},
	[LOGIN_SUCCESSFUL]: (state, action) => {
		return { ...state, user: action.payload, modalOpen: false}
	},
	[ASK_FOR_LOGIN]: (state, action) => {
		return { ...state, user: null, modalOpen: true, loading: false}
	},
	[AUTO_LOGIN]: (state, action) => {
		return { ...state, user: action.payload, modalOpen: false}
	},
	[LOGOUT]: (state, action) => {
		localForage.clear()
		return { ...state, user: null, modalOpen: true}	
	}
}

// ------------------------------------
// Reducer
// ------------------------------------
let _user = null
const initialState = { user: _user, modalOpen: true, loading: false }
export default function authReducer (state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type]
	return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/auth.js